/**
 * AgentCardFloating
 * 
 * @Author: Focci
 * @Date: 2023-12-03 10:59:05
 * @Last Modified by: Focci
 * @Last Modified time: 2023-12-03 10:59:05
 */

'use client'

import useLazyComponent from '@hook/useLazyComponent'
import Advert from '@comp/page/common/ad'
import useApp from '@hook/useApp'
import { filter } from 'lodash-es'
import { useCallback, useMemo } from 'react'
import { Waypoint } from 'react-waypoint'
import { getEnquiryProps } from '../lib'

export default function AgentCardFloating({
  isPublisher,
  isSoldOrEstimate,
  hasAgents,
  hasProperty,
  house = {},
  mobile, // 是否在移动端显示, 不设置两端都显示, false pc显示；true 移动端显示
}) {
  const { isMobile } = useApp()
  const { Wedget: AgentCard, getWedget: getAgentCard, ready: agentReady } = useLazyComponent()
  const { Wedget: PublisherCard, getWedget: getPublisherCard, ready } = useLazyComponent()
  // const { Wedget: AdvertGoogle, getWedget: getAdvertGoogle } = useLazyComponent()
  const { Wedget: ClaimListing, getWedget: getClaimListing, ready: claimReady } = useLazyComponent()

  const enquiryProps = getEnquiryProps(house)

  const isEstimate = useMemo(() => isSoldOrEstimate && hasProperty, [hasProperty, isSoldOrEstimate])
  const hasPremiumAgent = useMemo(() => (
    hasAgents && filter(house.agents, (f) => f.membership_level === 3).length > 0
  ), [hasAgents, house.agents])
  
  const isSales = useMemo(
    () => (isPublisher || !isSoldOrEstimate || hasPremiumAgent), 
    [isPublisher, isSoldOrEstimate, hasPremiumAgent]
  )
  
  const handleEnter = useCallback(() => {
    if(isSales) {
      if(isPublisher) {
        getPublisherCard(() => import('@page/property/publisher-card'))
      } else {
        getAgentCard(() => import('@page/property/agent-card')) 
      }
      // getAdvertGoogle(async () => (await import('@comp/page/common/ad')).AdvertGoogle)
    }
    if(isEstimate) {
      getClaimListing(() => import('@comp/page/property/estimate/ClaimListing'))
    }
  }, [getAgentCard, getClaimListing, getPublisherCard, isEstimate, isPublisher, isSales])

  const className = useMemo(() => {
    const tmp = ['sticky flex flex-col gap-4']
    if(isSales) {
      tmp.push(isPublisher ? 'top-4' : 'top-16')
    }
    if(isEstimate) {
      tmp.push(hasAgents ? 'top-16' : 'top-4')
    }

    return tmp.join(' ')
  }, [hasAgents, isEstimate, isPublisher, isSales])

  if(!(mobile === undefined || mobile === isMobile)) {
    return null
  }

  return (
    <Waypoint onEnter={handleEnter}>
      <div className={className}>
        {isSales && !isPublisher && (
          <div className="min-h-[10rem]" id="listing_agent_enquiry">
            <AgentCard 
              {...enquiryProps}
              isSoldPremuim={isSoldOrEstimate && hasPremiumAgent} 
            />
          </div>
        )}
        {isSales && isPublisher && (
          <div className="min-h-[390px]" id="listing_agent_enquiry">
            <PublisherCard house={house} />
          </div>
        )}
        {isEstimate && <ClaimListing propertyId={house.propertyId} />}
        {(agentReady || ready || claimReady) && (
          <>
            {/* <AdvertGoogle
              id="div-gpt-ad-1554333910477-0"
              dfpPath="/4439966/P1_300x250_HG_Web"
              advertProps={{ width: 300, height: 250 }}
            /> */}
            <Advert
              locationId={isSoldOrEstimate ? 2000 : 2064}
              width={300}
              height={250}
            />
          </>
        )}
      </div>
    </Waypoint>
  )
}
